
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 17 17","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke-width":"2"}},[_c('path',{attrs:{"d":"M1 1l15 15","stroke":"currentColor"}}),_c('path',{attrs:{"d":"M16 1L1 16","stroke":"CurrentColor"}})])])
          )
        }
      }
    